import request from '@/utils/request'


// 查询咨询消息列表
export function queryByPage(query) {
  return request({
    url: '/cnpWords/list',
    method: 'get',
    params: query
  })
}

//根据id查看专家详情
export function queryById(id) {
  return request({
    url: '/cnpWords/' + id,
    method: 'get',
  })
}

// 新增咨询消息（供应商）
export function addNew(data) {
  return request({
    url: '/cnpWords/add',
    method: 'post',
    data: data
  })
}


// 逻辑删除资质
export function deleteByIds(id) {
  return request({
    url: '/cnpWords/' + id,
    method: 'delete'
  })
}

// 编辑资质
export function updateById(id,data) {
  return request({
    url: '/cnpWords/' + id,
    method: 'put',
    data: data
  })
}
















// WEBPACK FOOTER //
// ./src/api/words/words.js